import { render, staticRenderFns } from "./dcheck.vue?vue&type=template&id=2f664b89&scoped=true&"
import script from "./dcheck.vue?vue&type=script&lang=js&"
export * from "./dcheck.vue?vue&type=script&lang=js&"
import style0 from "./dcheck.vue?vue&type=style&index=0&id=2f664b89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f664b89",
  null
  
)

export default component.exports